/**
 * TextColorButton
 * Toolbar button for setting text color
 */
import React from 'react';
import { TEXT_COLORS } from '../constants';
import { getTextColor, setTextColor } from '../editor.utils';
import ColorPickerButton from './ColorPickerButton';

const TextColorButton = () => {
  return (
    <ColorPickerButton
      icon='format_color_text'
      title='Text color'
      colors={TEXT_COLORS}
      getColor={getTextColor}
      setColor={setTextColor}
      removeLabel='Remove color'
      showIndicator={true}
      gridColumns={10}
    />
  );
};

TextColorButton.displayName = 'TextColorButton';

export default TextColorButton;
